import { render } from "./SendersAddComponent.vue?vue&type=template&id=5ba0df81&scoped=true"
import script from "./SendersAddComponent.vue?vue&type=script&lang=js"
export * from "./SendersAddComponent.vue?vue&type=script&lang=js"

import "./SendersAddComponent.vue?vue&type=style&index=0&id=5ba0df81&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba0df81"]])

export default __exports__